import { useParams } from 'react-router-dom';
import { modelVersions } from '../services/constants';
/**
 * Formats a string to a formatted valid number string
 * @param {string} raw - the input string (from user input)
 * @returns {string} - the formatted output string (for model input) #.##
 */
export const formatIonInputValue = (raw) => {
    try {
        const trimmed = raw.trim();
        if (trimmed === '') {
            return trimmed;
        } else {
            const float = parseFloat(raw.replace(',', '.'));
            if (isNaN(float)) {
                throw new Error('Cannot convert input to number');
            }
            const formatted = String(float.toFixed(2));
            return formatted;
        }
    } catch (err) {
        console.warn(err);
        return '';
    }
};

export const reuseDrainwaterPossible = ({
    modelVersion,
    selectedCropParameter,
    selectedSubstrate,
}) => {
    if (modelVersion === modelVersions.substraat) {
        return selectedSubstrate?.drainReuse;
        // return selectedCropParameter
        //     ? selectedCropParameter.drainReuse && selectedSubstrate !== 'kokos'
        //     : true;
    } else {
        return true;
    }
};

let baseKeys;
export const useLocalStorage = () => {
    const params = useParams();
    const { company } = params || {};
    const urlBasePath = window.location.pathname.split('/').filter((d) => d);
    // Only works because we use the hash router!

    baseKeys = baseKeys ?? [...urlBasePath, company].filter((d) => d);

    const getFullKey = (key) => [...baseKeys, key].join('.');

    const storeValue = (key, value) => {
        localStorage.setItem(getFullKey(key), value);
    };

    const readValue = (key) => {
        return localStorage.getItem(getFullKey(key));
    };

    const removeItem = (key) => {
        localStorage.removeItem(getFullKey(key));
    };

    return {
        storeValue,
        readValue,
        removeItem,
    };
};
